import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';
import { bindActionCreators } from 'redux';
import Form from '../../components/forms/FinancialinstitutionsForm';
import { breadcrumbs } from '../../../../actions/appActions';
import { saveFinancialinstitutions, withRedirect } from '../../CroActions';

const selector = formValueSelector('financialinstitutionsForm');

const mapStateToProps = (state) => ({
  breadcrumbsItems: [{ label: 'Finanční instituce' }, { label: 'Nová finanční instituce' }],
  loginData: { name: selector(state, 'name') },
  allowBasic: selector(state, 'allowBasic'),
  isNew: true,
});

const onSubmit = url => withRedirect(saveFinancialinstitutions(url), `${url}/financni-instituce`);

const mapDispatchToProps = (dispatch, { auth }) => ({
  ...bindActionCreators({ onSubmit: onSubmit(auth.startUrl), breadcrumbs }, dispatch),
})

export default connect(mapStateToProps, mapDispatchToProps)(Form);


